import React from 'react';
import { Controller } from 'react-hook-form';
import Select from 'react-select';
import styles from './Datalist.module.css';
import AsyncSelect from 'react-select/async';

const Datalist = ({
  options,
  className,
  name,
  label,
  inputRef,
  errors,
  control,
  defaultValue,
  onChange: onChangeFn,
  async,
  loadOptions,
  quantidadeMinimaCaracteres = 3,
  mensagem,
  ...rest
}) => {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      color: '#555577',
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      padding: 'initial',
    }),
    container: (provided, state) => ({
      ...provided,
      width: '100%',
    }),
    input: (provided, state) => ({
      ...provided,
      color: '#807569',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'white',
      backgroundColor: '#0071ad',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      backgroundColor: '#0071ad',
      '& > svg': {
        fill: 'white',
      },
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'white',
      color: '#807569',
      height: '62px',

      border:
        state.selectProps.className === 'invalid'
          ? '1px solid lightcoral'
          : state.isFocused
          ? '1px solid #0071ad'
          : '1px solid #807569',
      padding: '0.0125rem 0.9375rem',
      borderRadius: '5px',
      boxShadow:
        state.selectProps.className === 'invalid'
          ? '0 0 0 2px lightcoral'
          : state.isFocused
          ? '0 0 0 2px #0071ad'
          : 'none',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition, color: '#807569' };
    },
  };
  const msgErro = errors && errors[name]?.message;

  const selectProps = {
    styles: customStyles,
    isClearable: true,
    noOptionsMessage: () => mensagem,
    className: msgErro ? 'invalid' : '',
    ...rest,
  };

  return (
    <div
      className={`${styles.selectContainer} campo ${
        className ? className : ''
      }`}
    >
      <div className="subtitulo-p">
        <label htmlFor="numero">{label}</label>
      </div>
      <div className="controle">
        <Controller
          control={control}
          defaultValue={defaultValue || null}
          name={name}
          render={({ onChange, value, name, ref }) =>
            async ? (
              <AsyncSelect
                inputRef={ref}
                onChange={(val) => {
                  onChange(val || null);
                  if (onChangeFn) onChangeFn(val || null);
                }}
                {...selectProps}
                placeholder={`Digite no mínimo ${quantidadeMinimaCaracteres} caracteres`}
                loadOptions={async (value) => {
                  if (value.length >= quantidadeMinimaCaracteres)
                    return await loadOptions(value);
                }}
                loadingMessage={() => 'Carregando ...'}
                noOptionsMessage={(data) => {
                  return data.inputValue.length < quantidadeMinimaCaracteres
                    ? `Digite no mínimo ${quantidadeMinimaCaracteres} caracteres`
                    : 'Nenhum item existe contendo os termos digitados';
                }}
                defaultValue={defaultValue}
              />
            ) : (
              <Select
                inputRef={ref}
                options={options}
                value={options.find((c) => c.value === value) || null}
                onChange={(val) => {
                  onChange(val?.value || null);
                  onChangeFn(val?.value || null);
                }}
                {...selectProps}
              />
            )
          }
        />
      </div>
      <div className="mensagem">{msgErro}</div>
    </div>
  );
};

export default Datalist;
